import React, { useState, useEffect } from 'react';
import "./TinderCards.css";
import TinderCard from "react-tinder-card";
import db from "./firebase";

function TinderCards() {

    const [people, setPeople] = useState([
        // {
        //     "name": "Denzel Washington",
        //     "imgurl": "https://consequenceofsound.net/wp-content/uploads/2020/05/Denzel-Washington-1.jpg?quality=80&w=700&is-pending-load=1"
        // },
        // {
        //     "name": "Chadwick Boseman",
        //     "imgurl": "https://s.yimg.com/uu/api/res/1.2/hCZDgwXcNFz81HVg_Hq9sw--~B/aD0xNDQwO3c9MTQ0MDtzbT0xO2FwcGlkPXl0YWNoeW9u/https://media.zenfs.com/en/popsugar_celebrity_142/65899139e35b9883bb4d29acf9c1a8db"
        // },
    ]);

    useEffect(() => {

        const unsubscribe =
            db.collection("people")
                .onSnapshot((snapshot) =>
                    setPeople(snapshot.docs.map(doc => doc.data()))
                );

        return () => {
            unsubscribe();
            // reattach  a listner after change and not too much listner
        };

    }, [])

    console.log(people);

    const swiped = (direction, nameToDelete) => {
        console.log("removing: " + nameToDelete);
        // setLastDirection(direction);
    };

    const outOfFrame = (name) => {
        console.log(name + ' left the screen')
    };

    return (
        <div className="tinderCards">
            <div className="tinderCards__cardContainer">

                {people.map((person) => (
                    // <h1>{person.name}</h1>
                    <TinderCard
                        className='swipe'
                        key={person.name}
                        preventSwipe={["up", "down"]}
                        onSwipe={(dir) => swiped(dir, person.name)}
                        onCardLeftScreen={() => outOfFrame(person.name)}
                    >
                        <div style={{ backgroundImage: `url(${person.imgurl})` }} className="card">
                            <h3>{person.name}</h3>
                        </div>
                    </TinderCard>
                ))}

            </div>
        </div>
    )
}

export default TinderCards
